import { useDispatch } from 'react-redux';

import { _store } from '../combineReducerInitializer';

type AppDispatch = typeof _store.dispatch;

const useAppDispatch: () => AppDispatch = useDispatch;

export default useAppDispatch;
